import React from 'react'
import { SelectInputProps } from 'react-admin'
import { RAInputProps } from 'types/common'
import KSelectInput from 'ui-shared/WrappedInputs/KSelectInput'
import CustomReferenceInput from './CustomReferenceInput'

const SupplierSelectInput: React.FC<RAInputProps & SelectInputProps> = (
  props
) => {
  return (
    <CustomReferenceInput entity="suppliers">
      <KSelectInput {...props} label="Supplier" />
    </CustomReferenceInput>
  )
}

export default SupplierSelectInput
